import { useState, useEffect } from 'react';

import { useParams } from 'src/routes/hooks';

import { getOrder } from 'src/data/api';

import { InvoicePDFViewer } from 'src/sections/invoice/view';
import { useMediaQuery } from '@mui/material';

// ----------------------------------------------------------------------

const metadata = { title: `Ordre` };

export default function Invoice() {
  const { id = '' } = useParams();
  const isMobile = useMediaQuery('(max-width: 768px)');

  const [order, setOrder] = useState<any>(null);

  useEffect(() => {
    getOrder(id).then((res) => {
      setOrder(res);
    });
  }, []);

  return (
    <>
      <title>{metadata.title}</title>
      {order && <div style={{ height: isMobile ? '100%' : '100vh', overflow: 'hidden' }}>
        <InvoicePDFViewer order={order} />
      </div>
      }
    </>
  );
}
